// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    login as loginApi,
    logout as logoutApi,
    loginInfotools as loginInfotoolsApi,
    logoutInfotools as logoutInfotoolsApi,
    signup as signupApi,
    forgotPassword as forgotPasswordApi,
    forgotPasswordConfirm,
    updateDestinationInToken as updateDestinationInTokenApi,
} from '../../helpers/';

import { APICore, setAuthorization, setAuthorizationInfotools } from '../../helpers/api/apiCore';
import { authApiResponseSuccess, authApiResponseError } from './actions';
import { AuthActionTypes } from './constants';

const api = new APICore();

/**
 * Login the user
 * @param {*} payload - username and password
 */
function* login({ payload: { username, password } }) {
    try {
        const response = yield call(loginApi, { username, password });
        const user = response.data;
        // NOTE - You can change this according to response format from your api
        api.setLoggedInUser(user);
        setAuthorization(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* loginInfotools({ payload: credentials }) {
    try {
        const response = yield call(loginInfotoolsApi,{...credentials});
        const user = response.data;
        // NOTE - You can change this according to response format from your api
        api.setLoggedInUserInfotools(user);
        setAuthorizationInfotools(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER_INFOTOOLS, user));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER_INFOTOOLS, error));
        api.setLoggedInUserInfotools(null);
        setAuthorizationInfotools(null);
    }
}

function* updateAvatar({payload:{avatar}}) {
    try{
        const loggedUser  = api.getLoggedInUser()
        const user = {...loggedUser,avatar}
        api.setLoggedInUser(user)
        yield put(authApiResponseSuccess(AuthActionTypes.UPDATE_AVATAR,user))
    } catch(error){
        yield put(authApiResponseError(AuthActionTypes.UPDATE_AVATAR,error))
    }
}

/**
 * Logout the user
 */
function* logout() {
    try {
        yield call(logoutApi);
        api.setLoggedInUser(null);
        setAuthorization(null);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {}));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
    }
}

function* logoutInfotools() {
    try {
        yield call(logoutInfotoolsApi);
        api.setLoggedInUserInfotools(null);
        setAuthorizationInfotools(null);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER_INFOTOOLS, {}));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER_INFOTOOLS, error));
    }
}

function* signup({ payload: { fullname, email, password } }) {
    try {
        const response = yield call(signupApi, { fullname, email, password });
        const user = response.data;
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.SIGNUP_USER, user));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.SIGNUP_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* forgotPassword({ payload: { username } }) {
    try {
        const response = yield call(forgotPasswordApi, { username });
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, response.data));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, error));
    }
}

function* forgotPasswordChange({ payload: { data } }) {
    try {
        const response = yield call(forgotPasswordConfirm, data);
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD_CHANGE, response.data));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD_CHANGE, error));
    }
}

function* updateDestinationInToken({payload:data}) {
    try {
        const response = yield call(updateDestinationInTokenApi, data); 
        const dataTokenAndDestination = response.data;
        api.setUpdatedToken(dataTokenAndDestination)
        const newToken = dataTokenAndDestination.newToken
        yield put(authApiResponseSuccess(AuthActionTypes.UPDATE_DESTINATION_IN_TOKEN, newToken));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.UPDATE_DESTINATION_IN_TOKEN, error));
    }
}

export function* watchLoginUser(): any {
    yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchLoginUserInfotools(): any {
    yield takeEvery(AuthActionTypes.LOGIN_USER_INFOTOOLS, loginInfotools);
}

export function* watchLogout(): any {
    yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchLogoutUserInfotools(): any {
    yield takeEvery(AuthActionTypes.LOGOUT_USER_INFOTOOLS, logoutInfotools);
}

export function* watchSignup(): any {
    yield takeEvery(AuthActionTypes.SIGNUP_USER, signup);
}

export function* watchForgotPassword(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

export function* watchForgotPasswordChange(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD_CHANGE, forgotPasswordChange);
}

export function* watchUpdateAvatar():any{
    yield takeEvery(AuthActionTypes.UPDATE_AVATAR,updateAvatar)
}

export function* watchUpdateDestinationInToken(): any {
    yield takeEvery(AuthActionTypes.UPDATE_DESTINATION_IN_TOKEN, updateDestinationInToken);
}

function* authSaga(): any {
    yield all([
        fork(watchLoginUser),
        fork(watchLoginUserInfotools),
        fork(watchLogout),
        fork(watchLogoutUserInfotools),
        fork(watchSignup),
        fork(watchForgotPassword),
        fork(watchForgotPasswordChange),
        fork(watchUpdateAvatar),
        fork(watchUpdateDestinationInToken),
    ]);
}

export default authSaga;
